export default __webpack_public_path__ + "static/media/Teila.36b994b2.jpg";